// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitCustomControlCalendarDay__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchUnitCustomControlCalendar/SearchUnitCustomControlCalendarDay.scss
 ** module id = 933
 ** module chunks = 1
 **/